import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { twMerge } from 'tailwind-merge'

export interface IconCounterProps {
  icon: IconProp
  count?: number
  className?: string
  iconClassName?: string
  halfIconClassName?: string
}

export function IconCounter({ icon, count = 1, className, iconClassName, halfIconClassName }: IconCounterProps) {
  const wholeIcons = Math.floor(count)
  const showHalfIcon = wholeIcons < count

  return (
    <div className={twMerge(`flex items-center ${className ?? ''}`)}>
      {Array(wholeIcons)
        .fill('')
        .map((_, i) => (
          <div key={i} className={iconClassName}>
            <FontAwesomeIcon icon={icon} className="pr-2 text-xl" data-testid="icon" />
          </div>
        ))}
      {showHalfIcon ? (
        <div className={twMerge(`w-[10px] overflow-hidden ${halfIconClassName ?? ''}`)}>
          <FontAwesomeIcon icon={icon} className="text-xl" data-testid="half-icon" />
        </div>
      ) : null}
    </div>
  )
}
